export default "__VITE_ASSET__CbOfu2I5__"